import { render, staticRenderFns } from "./InputDataTemplate.vue?vue&type=template&id=f234ba02&scoped=true&"
import script from "./InputDataTemplate.vue?vue&type=script&lang=js&"
export * from "./InputDataTemplate.vue?vue&type=script&lang=js&"
import style0 from "./InputDataTemplate.vue?vue&type=style&index=0&id=f234ba02&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f234ba02",
  null
  
)

export default component.exports